import styled from 'styled-components';

export const Menu = styled.div`
  box-sizing: border-box;
`;

export const Container = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
`;

export const Ul = styled.ul`
  display: flex;
  overflow: hidden;
`;

export const li = styled.li`
  flex-shrink: 1;
  &:not(:last-child) {
    width: 220px;
  }
  &:last-child {
    flex-shrink: 0;
  }
`;

export const Title = styled.div`
  text-align: left;
  line-height: 1;
  cursor: pointer;
  &:hover {
    color: rgba(19, 238, 179, 1);
  }
`;

export const Title1 = styled(Title)`
  margin-bottom: 35px;

  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
`;

export const Title2 = styled(Title)`
  &:not(:first-child) {
    margin-top: 18px;
  }

  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.8);
`;

export const QrCodeList = styled.div`
  display: flex;
  justify-content: space-around;
  flex-grow: 1;
  flex-shrink: 0;

  > .qr-code-wrapper {
    margin-left: 30px;
    > .qr-code-block {
      width: 116px;
      height: 119px;
      display: flex;
      align-items: center;
      justify-content: center;

      position: relative;
      > .bg {
        position: absolute;
        top: -18px;
        bottom: -19px;
        left: -18px;
        right: -20px;
        z-index: -10;

        background-image: url(${require('../img/qr-code-block-bg.png')});
        background-size: 100% 100%;
      }

      > .qr-code {
        width: 91px;
        height: 91px;
      }
    }

    > .title {
      margin-top: 6px;
      padding-top: 6px;
      padding-bottom: 6px;
      box-sizing: border-box;

      text-align: center;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 12px;

      width: 116px;
      position: relative;
      > .top-decorate {
        position: absolute;
        top: -3px;
        bottom: 0;
        left: 0;
        right: 0;

        background-image: url(${require('../img/qr-code-title-up.png')});
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: top center;
      }

      > .bottom-decorate {
        position: absolute;
        top: 0;
        bottom: -1px;
        left: 0;
        right: 0;

        background-image: url(${require('../img/qr-code-title-down.png')});
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: bottom center;
      }
    }
  }
`;
